import { useArtifact } from "../../hooks/useArtifacts.tsx";
import type {
  GetArtifactResp,
  HeavyArtifactResponse,
  UserResponseArtifact,
} from "../../types/artifacts.ts";
import type { SendMessageFn } from "../messages/hooks/useMessageList.tsx";
import HeavyArtifactItem from "./HeavyArtifactItem.tsx";
import { ResponseArtifactItem } from "./ResponseArtifactItem.tsx";

type ArtifactItemProps = {
  messageId: number;
  threadId: number;
  msgListArtifact: GetArtifactResp;
  sendMessage: SendMessageFn;
  shouldStreamContent?: boolean;
  closeArtifactGroup?: () => void;
  hideFooter?: boolean;
};

export const ArtifactItem = ({
  messageId,
  threadId,
  msgListArtifact,
  sendMessage,
  shouldStreamContent = false,
  closeArtifactGroup,
  hideFooter = false,
}: ArtifactItemProps) => {
  const { artifact } = useArtifact({
    threadId,
    messageId,
    artifact: msgListArtifact,
  });

  return (
    <>
      {artifact.isHeavy && (
        <HeavyArtifactItem
          messageId={messageId}
          threadId={threadId}
          msgListArtifact={artifact as HeavyArtifactResponse}
          closeArtifactGroup={closeArtifactGroup}
        />
      )}
      {artifact.artifactType === "userResponse" && (
        <ResponseArtifactItem
          artifact={artifact as UserResponseArtifact}
          messageId={messageId}
          threadId={threadId}
          sendMessage={sendMessage}
          shouldStreamContent={shouldStreamContent}
          hideFooter={hideFooter}
        />
      )}
    </>
  );
};
